import { render, staticRenderFns } from "./CuadraturaOrdenesServicioPantalla.vue?vue&type=template&id=4ed3eb14&"
import script from "./CuadraturaOrdenesServicioPantalla.vue?vue&type=script&lang=ts&"
export * from "./CuadraturaOrdenesServicioPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4ed3eb14', component.options)
    } else {
      api.reload('4ed3eb14', component.options)
    }
    module.hot.accept("./CuadraturaOrdenesServicioPantalla.vue?vue&type=template&id=4ed3eb14&", function () {
      api.rerender('4ed3eb14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/OrdenesServicio/CuadraturaOrdenesServicioPantalla.vue"
export default component.exports